// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueParallaxJs from 'vue-parallax-js'
import VueTyperPlugin from 'vue-typer'
import VueCookie from 'vue-cookie'
import VueCarousel from 'vue-carousel'
import VueResource from 'vue-resource'
import VueLazyload from 'vue-lazyload'
import VueScrollTo from 'vue-scrollto'
import VueAnalytics from 'vue-analytics'
import lodash from 'lodash'
import 'phantomjs-polyfill-includes'
// import {VueMasonryPlugin} from 'vue-masonry'
// import VuePackeryPlugin, {packeryEvents} from 'vue-packery-plugin'
import VuePackeryPlugin from 'vue-packery-plugin'

// Object.defineProperty(Vue.prototype, '$_', { value: lodash });

Vue.config.productionTip = false
Vue.use(VueParallaxJs, {absY: true, minWidth: 340})
Vue.use(VueTyperPlugin)
Vue.use(VueCookie)
Vue.use(VueCarousel)
Vue.use(VueResource)
Vue.use(VueScrollTo)
// Vue.use(VueMasonryPlugin)
Vue.use(VuePackeryPlugin)
Vue.use(VueLazyload, {
  preLoad: 1.8
})

Vue.use(VueAnalytics, {
  id: 'UA-36025122-1',
  router
})

Vue.http.interceptors.push((request, next) => {
  request.credentials = true
  next()
})

var PLs = Object.freeze(window.PLs)

const activePullSheet = {
  items: [],
  name: 'Untitled Pullsheet',
  token: false,
  loaded: false
}

const itemToAdd = {
  plno: false,
  url: false,
  trigger: false
}

const user = {
  loggedIn: false,
  session: false,
  email: false,
  token: false
}

var apiurl = 'https://api.productionlocations.com/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data: {
    PLs: PLs,
    categories: window.categories,
    sitecontent: window.sitecontent,
    pickedLocation: '',
    authorizedUser: false,
    addresses: [],
    difficulty: false,
    activePullSheet: activePullSheet,
    itemToAdd: itemToAdd,
    user: user,
    isTouch: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    apiurl: apiurl
  },
  computed: {
    currentLocation () {
      return this.PLs[this.pickedLocation]
    }
  },
  methods: {
    pickLocation: function pickLocation (plno) {
      var result = this.PLs.findIndex(function (pl) {
        return pl.plno === plno
      })
      this.pickedLocation = result
    },
    getTagById: function getTagById (tagid) {
      return findTagById(tagid, this.categories)
    },
    getTagBySlug: function getTagById (tagslug) {
      return findTagBySlug(tagslug, this.categories)
    },
    getPLsByTagId: function getPLsByTagId (tagid, pls) {
      var result = []
      if (pls === undefined) pls = this.PLs
      var tag = this.getTagById(tagid)
      if (tag.children !== undefined) {
        tag.children.forEach(function (childtag) {
          result = result.concat(pls.filter(function (pl) {
            return pl.tagids.indexOf(+childtag.id) > -1
          }))
        })
      } else {
        result = pls.filter(function (pl) {
          return pl.tagids.indexOf(+tagid) > -1
        })
      }
      return result
    },
    filterByTags: function getPLsByTags (tags) {
      var tagids = []
      tags.forEach(function (tag) {
        tagids.push(+tag.id)
        if (tag.children !== undefined) {
          tag.children.forEach(function (childtag) {
            tagids.push(+childtag.id)
          })
        }
      })
      var pltagids = []
      var filteredPLs = this.PLs.filter(function (pl) {
        if (lodash.intersection(pl.tagids, tagids).length === tagids.length) {
          pltagids = lodash.concat(pltagids, pl.tagids)
          return true
        }
      })
      return {
        pls: filteredPLs,
        tagcounts: lodash.countBy(pltagids)
      }
    },
    getTagsFromPLs: function getTagsFromPLs (pls) {
      var tagidcounts = {}
      var result = []
      pls.forEach(function (pl) {
        pl.tagids.forEach(function (tagid) {
          if (tagidcounts[tagid] === undefined) tagidcounts[tagid] = 0
          tagidcounts[tagid]++
        })
      })

      for (var tagid in tagidcounts) {
        if (tagidcounts.hasOwnProperty(tagid)) {
          var tagcount = tagidcounts[tagid]
          var tagobject = this.getTagById(tagid)
          tagobject.filteredcount = tagcount
          result.push(tagobject)
        }
      }

      return result
    },
    filterListingPhotos: function filterListingPhotos (photos, photofilter, tagids) {
      if (photofilter === 'default') {
        return photos.slice(0, 10)
      }
      if (photofilter === 'relevant') {
        var result = []
        var unused = []
        photos.forEach(function (photo) {
          if (photo.tags === undefined) {
            unused.push(photo)
            return
          }
          var matchedtags = photo.tags.filter(function (value) {
            return tagids.indexOf(value) > -1
          })
          if (matchedtags.length) {
            result.push(photo)
          } else {
            unused.push(photo)
          }
        })
        if (result.length >= 10) {
          return result.slice(0, 9)
        } else {
          return result.concat(unused).slice(0, 9)
        }
      }
    },
    fetchAddresses: function fetchData () {
      this.$http.get('https://api.productionlocations.com/admininfo').then(response => {
        var zipcodes = {}
        for (var i = 0, len = response.body.addresses.length; i < len; i++) {
          var zipcode = response.body.addresses[i].zip.trim()
          if (zipcode in zipcodes) {
            zipcodes[zipcode].plcount++
            zipcodes[zipcode].pls.push(response.body.addresses[i].plno)
          } else {
            zipcodes[zipcode] = {plcount: 1, pls: [response.body.addresses[i].plno]}
          }
          var plindex = this.PLs.findIndex(function (pl) {
            return pl.plno === response.body.addresses[i].plno
          })
          this.PLs[plindex].tagids.push(+zipcode)
        }

        var catindex = this.categories.push({
          id: 99,
          name: 'Zip',
          tags: []
        })
        catindex--
        Object.keys(zipcodes).forEach((zipcode) => {
          this.categories[catindex].tags.push({
            id: zipcode,
            name: zipcode,
            slug: zipcode,
            plcount: zipcodes[zipcode].plcount
          })
        })

        this.addresses = response.body.addresses
        this.difficulty = response.body.difficulty
      }, response => {
        console.log(response.statusText)
      })
    },
    logActivity: function (activity) {
      this.$http.get(this.apiurl + 'log/enter', {
        params: {
          action: activity
        }
      }).then(response => {
//         console.log(response)
      }, response => {
        console.log(response.statusText)
      })
    }
  },
  created () {
    if (this.$cookie.get('plu') !== null) {
      var usercookie = this.$cookie.get('plu').split('||')
      this.user.email = usercookie[0]
      this.user.token = usercookie[1]
      this.user.session = true
      this.user.loggedIn = true
    }
    if (this.$cookie.get('pla') !== null) {
      this.user.token = this.$cookie.get('pla')
      this.user.session = true
    }
    if (this.$cookie.get('plsa') !== null) {
      this.authorizedUser = true
    }
    if (this.authorizedUser) {
      this.fetchAddresses()
    }
  },
  template: '<App/>',
  components: { App }
})

function findTagById (id, categories, loopback) {
  var i, ii, result

  for (i = 0; i < categories.length; i += 1) {
    for (ii = 0; ii < categories[i].tags.length; ii += 1) {
      if (categories[i].tags[ii].id === id) {
        result = categories[i].tags[ii]
        result.categoryid = categories[i].id
        result.categoryname = categories[i].name
        return result
      } else {
        if (categories[i].tags[ii].children !== undefined) {
          result = findTagIdRecursive(id, categories[i].tags[ii].children)

          if (result !== false) {
            result.parent = categories[i].tags[ii]
            result.categoryid = categories[i].id
            result.categoryname = categories[i].name
            return result
          }
        }
      }
    }
  }
}

function findTagIdRecursive (id, tags) {
  var i, result
  for (i = 0; i < tags.length; i += 1) {
    if (tags[i].id === id) {
      return tags[i]
    } else {
      if (tags[i].children !== undefined) {
        result = findTagIdRecursive(id, tags[i].children)
        if (result !== false) return result
      }
    }
  }
  return false
}

function findTagBySlug (slug, categories, loopback) {
  var i, ii, result

  for (i = 0; i < categories.length; i += 1) {
    for (ii = 0; ii < categories[i].tags.length; ii += 1) {
      if (categories[i].tags[ii].slug === slug) {
        result = categories[i].tags[ii]
        result.categoryid = categories[i].id
        result.categoryname = categories[i].name
        return result
      } else {
        if (categories[i].tags[ii].children !== undefined) {
          result = findTagSlugRecursive(slug, categories[i].tags[ii].children)

          if (result !== false) {
            result.parent = categories[i].tags[ii]
            result.categoryid = categories[i].id
            result.categoryname = categories[i].name
            return result
          }
        }
      }
    }
  }
}

function findTagSlugRecursive (slug, tags) {
  var i, result
  for (i = 0; i < tags.length; i += 1) {
    if (tags[i].slug === slug) {
      return tags[i]
    } else {
      if (tags[i].children !== undefined) {
        result = findTagSlugRecursive(slug, tags[i].children)
        if (result !== false) return result
      }
    }
  }
  return false
}

if (!Array.prototype.findIndex) {
  Array.prototype.findIndex = function (predicate) {
    if (this === null) {
      throw new TypeError('Array.prototype.findIndex called on null or undefined')
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function')
    }
    var list = Object(this)
    var length = list.length >>> 0
    var thisArg = arguments[1]
    var value

    for (var i = 0; i < length; i++) {
      value = list[i]
      if (predicate.call(thisArg, value, i, list)) {
        return i
      }
    }
    return -1
  }
}
/*
if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement) {
    'use strict'
    if (this == null) {
      throw new TypeError('Array.prototype.includes called on null or undefined')
    }
    var O = Object(this)
    var len = parseInt(O.length, 10) || 0
    if (len === 0) {
      return false
    }
    var n = parseInt(arguments[1], 10) || 0
    var k
    if (n >= 0) {
      k = n
    } else {
      k = len + n
      if (k < 0) { k = 0 }
    }
    var currentElement
    while (k < len) {
      currentElement = O[k]
      if (searchElement === currentElement) {
        return true
      }
      k++
    }
    return false
  }
}
*/



// WEBPACK FOOTER //
// ./src/main.js